import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";

type MaintenanceExitPopupProps = {
  isOpen: boolean;
  isSaving?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const MaintenanceExitPopup: React.FC<MaintenanceExitPopupProps> = ({
  isOpen,
  isSaving = false,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <Popup
      title="Maintenance"
      onClose={onClose}
      portal
      fixSize="small"
      closeOnOutsideClick={false}
      commandPanelProps={{
        additionalElement: (
          <group data-justify="right" data-gap="10">
            <Button type="button" onClick={onClose} disabled={isSaving}>
              Cancel
            </Button>
            <Button type="button" primary onClick={onConfirm} disabled={isSaving}>
              Ok
            </Button>
          </group>
        ),
      }}
    >
      <group data-space="20" data-height="autofit">
        <text>Confirm exit from maintenance?</text>
      </group>
    </Popup>
  );
};

export default MaintenanceExitPopup;
